/* eslint-disable no-console */
/* eslint-disable react/prop-types */

import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { ErrorPage } from '../ErrorPage';

function ErrorBoundary({ children }) {
  const [hasError, setHasError] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (hasError) {
      setHasError(false);
    }
  }, [location.key]);

  return (
    <ErrorBoundaryInner hasError={hasError} setHasError={setHasError}>
      {children}
    </ErrorBoundaryInner>
  );
}

class ErrorBoundaryInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps) {
    if (!this.props.hasError && prevProps.hasError) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    this.props.setHasError(true);
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
